import { render, staticRenderFns } from "./ContentCreate.vue?vue&type=template&id=2019ab52&"
import script from "./ContentCreate.vue?vue&type=script&lang=js&"
export * from "./ContentCreate.vue?vue&type=script&lang=js&"
import style0 from "./ContentCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports